import Loadable from "../utils/loadable";

export const Navigation = Loadable(() =>
  import(/* webpackChunkName: "Navigation" */ "./Navigation/Navigation")
);

export const ConsignedOrder = Loadable(() =>
  import(/* webpackChunkName: "Consigned Order" */ "./ConsignedOrder/ConsignedOrder")
);

export const Partners = Loadable(() =>
  import(/* webpackChunkName: "Partners" */ "./Partners/Partners")
);

export const EZDParameters = Loadable(() =>
  import(/* webpackChunkName: "EZDParameters" */ "./EZDParameters/EZDParameters")
);

export const Products = Loadable(() =>
  import(/* webpackChunkName: "Products" */ "./Products/Products")
);

export const sellableProduct = Loadable(() =>
  import(/* webpackChunkName: "Products" */ "./SellableProduct/SellableProduct")
);

export const AccountBalance = Loadable(() =>
  import(/* webpackChunkName: "Products" */ "./AccountBalance/AccountBalance")
);

export const MonthLocks = Loadable(() =>
  import(/* webpackChunkName: "MonthLocks" */ "./MonthLocks/MonthLocks")
);

export const PaymentTerms = Loadable(() =>
  import(/* webpackChunkName: "PaymentTerms" */ "./PaymentTerms/PaymentTerms")
);

export const IngestionMonitor = Loadable(() =>
  import(/* webpackChunkName: "IngestionMonitor" */ "./IngestionMonitor/IngestionMonitor")
);

export const RollabckIngestion = Loadable(() =>
  import(/* webpackChunkName: "RollabckIngestion" */ "./RollbackIngestion/RollbackIngestion")
);

export const WSPartners = Loadable(() =>
  import(/* webpackChunkName: "WSPartners" */ "./WSPartners/WSPartners")
);